import { FamilyPersonality } from "../types/families";

export const FAMILY_COLLABORATIVE_PERSONALITY = 'Collaborativa' as const;
export const FAMILY_QUITE_PERSONALITY = "Tranquilla" as const;
export const FAMILY_NICE_PERSONALITY = 'Dolce' as const;
export const FAMILY_CALM_PERSONALITY = 'Calma' as const;
export const FAMILY_EMOTIONAL_PERSONALITY = 'Sensibile' as const;
export const FAMILY_LITTLE_SPEAK_PERSONALITY = 'Parla poco' as const;
export const FAMILY_NEEDS_COMPANY_PERSONALITY = 'Bisogno di compagnia' as const;
export const FAMILY_NEEDS_AFFECTION_PERSONALITY = 'Bisogno di affetto' as const;
export const FAMILY_SHY_PERSONALITY = 'Schiva' as const;
export const FAMILY_AUTHORITARIAN_PERSONALITY = 'Autoritaria' as const;
export const FAMILY_STRONG_CHARACTER_PERSONALITY = 'Carattere forte' as const;
export const FAMILY_NON_COLLABORATIVE_PERSONALITY = 'Non collaborativa' as const;
export const FAMILY_PERSONALITIES = [
  FAMILY_COLLABORATIVE_PERSONALITY,
  FAMILY_QUITE_PERSONALITY,
  FAMILY_NICE_PERSONALITY,
  FAMILY_CALM_PERSONALITY,
  FAMILY_EMOTIONAL_PERSONALITY,
  FAMILY_LITTLE_SPEAK_PERSONALITY,
  FAMILY_NEEDS_COMPANY_PERSONALITY,
  FAMILY_NEEDS_AFFECTION_PERSONALITY,
  FAMILY_SHY_PERSONALITY,
  FAMILY_AUTHORITARIAN_PERSONALITY,
  FAMILY_STRONG_CHARACTER_PERSONALITY,
  FAMILY_NON_COLLABORATIVE_PERSONALITY
] as const;

export const FAMILY_PERSONALITIES_SELECTOR_DATA: {
  key: FamilyPersonality; 
  value: FamilyPersonality
}[] = [
  { key: 'Collaborativa', value: 'Collaborativa' },
  { key: 'Tranquilla', value: 'Tranquilla' },
  { key: 'Dolce', value: 'Dolce' },
  { key: 'Calma', value: 'Calma' },
  { key: 'Sensibile', value: 'Sensibile' },
  { key: 'Parla poco', value: 'Parla poco' },
  { key: 'Bisogno di compagnia', value: 'Bisogno di compagnia' },
  { key: 'Bisogno di affetto', value: 'Bisogno di affetto' },
  { key: 'Schiva', value: 'Schiva' },
  { key: 'Autoritaria', value: 'Autoritaria' },
  { key: 'Carattere forte', value: 'Carattere forte' },
  { key: 'Non collaborativa', value: 'Non collaborativa' }
];

export type WeekendNeedsValue = "Sì" | "No" | "Non sempre" | "Non serve";
export type NightSleepValue = "Sì" | "No" | "Si sveglia due o tre volte a settimana";
export type SurveillanceCamerasValue = "Sì" | "No";
export type SmokeAcceptanceValue = "Sì" | "No" | "Sì, ma l'importante è che fumi fuori casa";
export type FamilyOtherPeoplePresenceValue = "Sì" | "No" | "Vive solo";
export type CaregiverRoomPresence = "Sì" | "No";

export const FAMILY_WEEKEND_NEEDS_SLECTOR_DATA: {
  key: WeekendNeedsValue;
  value: WeekendNeedsValue
}[] = [
  { key: "Sì", value: "Sì" },
  { key: "No", value: "No" },
  { key: "Non sempre", value: "Non sempre" },
  { key: "Non serve", value: "Non serve" },
]

export const FAMILY_NIGHT_SLEEP_SLECTOR_DATA: {
  key: NightSleepValue;
  value: NightSleepValue
}[] = [
  { key: "Sì", value: "Sì" },
  { key: "No", value: "No" },
  { key: "Si sveglia due o tre volte a settimana", value: "Si sveglia due o tre volte a settimana" },
]

export const FAMILY_SMOKE_ACCEPTANCE_SLECTOR_DATA: {
  key: SmokeAcceptanceValue;
  value: SmokeAcceptanceValue
}[] = [
  { key: "Sì", value: "Sì" },
  { key: "No", value: "No" },
  { key: "Sì, ma l'importante è che fumi fuori casa", value: "Sì, ma l'importante è che fumi fuori casa" },
]

export const FAMILY_OTHER_PEOPLE_PRESENCE_SLECTOR_DATA: {
  key: FamilyOtherPeoplePresenceValue;
  value: FamilyOtherPeoplePresenceValue
}[] = [
  { key: "Sì", value: "Sì" },
  { key: "No", value: "No" },
  { key: "Vive solo", value: "Vive solo" },
]